export type GetUserSSCDetailsQuerySuccessResponseKeys =
  | 'board_name_enum'
  | 'institute_id'
  | 'institute_name'
  | 'other_institute_name'
  | 'completion_status'
  | 'score_type'
  | 'score'
  | 'year_of_completion'
  | 'score_in_maths'
  | 'institute_state_name'
  | 'cert_s3_url'
  | 'city_name';

const allSSCSuccessKeys: GetUserSSCDetailsQuerySuccessResponseKeys[] = [
  'board_name_enum',
  'institute_id',
  'institute_name',
  'other_institute_name',
  'completion_status',
  'score_type',
  'score',
  'year_of_completion',
  'score_in_maths',
  'institute_state_name',
  'cert_s3_url',
  'city_name'
];

const getUserSSCDetailsGraphQlQuery = (
  successKeys: GetUserSSCDetailsQuerySuccessResponseKeys[],
  withQuery = true
): string => {
  const keysToUse = successKeys?.length ? successKeys : allSSCSuccessKeys;

  const successFields = `success_response { ${keysToUse.join(' ')} }`;

  const failureFields = `failure_response { res_status response }`;

  if (withQuery) {
    return `
    query getUserSSCDetails{
      user_ssc_details{
        ${successFields}
        ${failureFields}
      }
    }
  `;
  } else
    return `
    user_ssc_details{
      ${successFields}
      ${failureFields}
    }
    `;
};

export { getUserSSCDetailsGraphQlQuery };
